<!-- Base Accordion Component -->
<template>
  <div class="w-full">
    <button
      @click="toggleAccordion"
      class="w-full flex justify-between items-center p-4 bg-gray-100 dark:bg-dark-700 rounded-lg focus:outline-none"
      :class="{ 'rounded-b-none': isOpen }"
    >
      <slot name="header"></slot>
      <ChevronDownIcon
        class="w-5 h-5 text-gray-500 transition-transform duration-200"
        :class="{ 'transform rotate-180': isOpen }"
      />
    </button>
    <div
      v-show="isOpen"
      class="bg-gray-100 dark:bg-dark-700 rounded-b-lg overflow-hidden transition-all duration-200"
    >
      <div class="p-4">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { ChevronDownIcon } from '@heroicons/vue/24/outline'

const isOpen = ref(false)

const toggleAccordion = () => {
  isOpen.value = !isOpen.value
}
</script>
